import React from "react";

const CARRIERS = [
  { name: "Mutual of Omaha", style: "font-serif-display italic" },
  { name: "AIG", style: "font-black tracking-tight" },
  { name: "Globe Life", style: "font-serif-display font-bold" },
  { name: "Aetna", style: "font-extrabold tracking-tight" },
  { name: "Gerber Life", style: "font-serif-display italic font-bold" },
  { name: "Foresters", style: "font-semibold tracking-wide" },
  { name: "Transamerica", style: "font-bold tracking-tight" },
  { name: "Prudential", style: "font-serif-display font-bold" },
  { name: "MetLife", style: "font-black tracking-wider" },
  { name: "John Hancock", style: "font-serif-display font-bold italic" },
];

const FEATURED_IN = [
  { name: "Forbes", style: "font-serif-display italic font-black" },
  { name: "SS Benefits", style: "font-bold tracking-tight" },
  { name: "AM Best A+", style: "font-bold tracking-wider" },
  { name: "BBB Accredited", style: "font-serif-display font-bold" },
];

export const TrustBadges = () => {
  return (
    <section
      data-testid="trust-badges-section"
      className="bg-slate-50 border-y border-slate-200 py-12 md:py-16"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        {/* Featured in */}
        <div className="text-center">
          <p className="text-xs md:text-sm uppercase tracking-[0.22em] font-semibold text-slate-500">
            As Featured In & Trusted By
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-10 gap-y-5">
            {FEATURED_IN.map((b) => (
              <span
                key={b.name}
                data-testid={`featured-${b.name.toLowerCase().replace(/\s+/g, "-")}`}
                className={`text-2xl md:text-3xl text-slate-700 ${b.style}`}
              >
                {b.name}
              </span>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="my-10 h-px bg-slate-200" />

        {/* Carriers shopped */}
        <div className="text-center">
          <p className="text-base md:text-lg font-semibold text-blue-900">
            We shop 30+ top-rated carriers to find your lowest rate
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-8 gap-y-4">
            {CARRIERS.map((c) => (
              <span
                key={c.name}
                data-testid={`carrier-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
                className={`text-lg md:text-xl text-slate-600 ${c.style}`}
              >
                {c.name}
              </span>
            ))}
            <span className="text-lg md:text-xl text-slate-500 italic">
              + 20 more…
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
